export function isInactiveMember(member: unknown): boolean {
  const m = member as { status?: unknown; is_active?: unknown; isActive?: unknown } | null | undefined
  if (!m) return false
  const flag = m.is_active ?? m.isActive
  if (flag === false || flag === 0 || flag === '0' || flag === 'false') return true
  return typeof m.status === 'string' && m.status.trim().toLowerCase() === 'inactive'
}

export function filterActiveMembers<T>(members: T[]): T[] {
  return (members || []).filter((m) => !isInactiveMember(m))
}
